function TrainingToBeEvaluated () {
  this.trainings = []
}
export default {
  namespaced: true,
  state: {
    trainingToBeEvaluated: new TrainingToBeEvaluated(),
    adminTrainingDialog: false,
    createOrUpdateExerciseAdminDialog: false,
    createOrUpdateExerciseAdmin: {},
    createOrUpdateExerciseAdminIndex: -1,
    trainingAdminIndex: -1
  },
  mutations: {
    SET_LIBRARY_TRAINING (state, training) {
      state.trainingToBeEvaluated.training = training
    },
    SET_TRAINING_TO_BE_EVALUATED (state, training) {
      state.trainingToBeEvaluated = Object.assign({}, training)
    },
    SET_CREATE_OR_UPDATE_EXERCISE_DIALOG (state, dialogState) {
      state.createOrUpdateExerciseAdminDialog = dialogState
    },
    SET_CREATE_OR_UPDATE_EXERCISE (state, exercise) {
      state.createOrUpdateExerciseAdmin = Object.assign({}, exercise)
    },
    SET_CREATE_OR_UPDATE_EXERCISE_INDEX (state, exerciseIndex) {
      state.createOrUpdateExerciseAdminIndex = exerciseIndex
    },
    SET_TRAINING_DIALOG (state, dialogState) {
      state.adminTrainingDialog = dialogState
    },
    SET_TRAINING_INDEX (state, trainingIndex) {
      state.trainingAdminIndex = trainingIndex
    },
    DESTROY_EXERCISE (state, { trainingIndex, exerciseIndex }) {
      state.trainingToBeEvaluated.trainings[trainingIndex].exercises.splice(exerciseIndex, 1)
    },
    RESET_DIALOG (state) {
      state.trainingToBeEvaluated = new TrainingToBeEvaluated()
    }
  },
  actions: {
    setTrainingToBeEvaluated ({ commit }, payload) {
      commit('SET_TRAINING_TO_BE_EVALUATED', payload)
    },
    setCreateOrUpdateExerciseAdminDialog ({ commit }, dialogState) {
      commit('SET_CREATE_OR_UPDATE_EXERCISE_DIALOG', dialogState)
    },
    setCreateOrUpdateExerciseAdmin ({ commit }, exercise) {
      commit('SET_CREATE_OR_UPDATE_EXERCISE', exercise)
    },
    setCreateOrUpdateExerciseAdminIndex ({ commit }, exerciseIndex) {
      commit('SET_CREATE_OR_UPDATE_EXERCISE_INDEX', exerciseIndex)
    },
    setTrainingAdminDialog ({ commit }, dialogState) {
      commit('SET_TRAINING_DIALOG', dialogState)
    },
    setTrainingAdminIndex ({ commit }, trainingIndex) {
      commit('SET_TRAINING_INDEX', trainingIndex)
    },
    destroyExerciseAdmin ({ commit }, { trainingIndex, exerciseIndex }) {
      commit('DESTROY_EXERCISE', { trainingIndex, exerciseIndex })
    },
    resetDialog ({ commit }) {
      commit('RESET_DIALOG')
    }
  },
  getters: {
    trainingToBeEvaluated: state => state.trainingToBeEvaluated,
    adminTrainingDialog: state => state.adminTrainingDialog,
    createOrUpdateExerciseAdmin: state => state.createOrUpdateExerciseAdmin,
    createOrUpdateExerciseAdminIndex: state => state.createOrUpdateExerciseAdminIndex,
    createOrUpdateExerciseAdminDialog: state => state.createOrUpdateExerciseAdminDialog,
    trainingAdminIndex: state => state.trainingAdminIndex
  }
}
